import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WebAddresses } from '../app.config';
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response';
import { globalUser } from '../helpers/globalFields';
import { Organization } from '../interfaces/organization';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
  ) {}

  private baseUrl = WebAddresses.TicketAuthorisation;

  getOrganizationListByUser(): Observable<Organization[]> {
    return this.http
      .get<ApiResponse>(`${this.baseUrl}/organization/findbyuser`, {
        headers: globalUser.getHeaders(),
      })
      .pipe(
        tap((response) => {

        }),
        map((response) => response.data ?? []),
        catchError(error => {
          console.error("Error",error);
          return throwError(() => new Error("Err"))
        })
      );
  }

  private currentOrgSubject = new BehaviorSubject<string | null>(null);
  currentOrg$ = this.currentOrgSubject.asObservable();

  setOrganization(orgName: string) {
    this.currentOrgSubject.next(orgName);
  }

  getCurrentOrganization(): string | null {
    return this.currentOrgSubject.value;
  }
}
